// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__33dVV","notes":"Notes_notes__3qvto","note":"Notes_note__3w4dE","markdown":"Notes_markdown__2weFs"};